/**
 * Measurements the merchant shell and its screens must agree on.
 *
 * A screen that pins its own header draws the top half of a horizontal rule:
 * the rail draws the other half. If each picks its own height the two borders
 * land a few pixels apart at the rail's edge and read as a mistake — which is
 * exactly what a collapsed rail did, its section divider sitting just above the
 * header's border.
 *
 * One constant is what keeps them one line. The class string is literal because
 * Tailwind reads class names from source text, and this file is inside the
 * app's content glob.
 */

/** The height of the tablet shell's top row, rail and screen header alike. */
export const SHELL_HEADER_HEIGHT = 'h-[73px]';
